import * as THREE from "three";
import { Vector3 } from "three";
import { getArrowAxes } from "./utils";
import { Text } from "@react-three/drei";

interface ArrowAxesProps {
  position: THREE.Vector3;
  rotation: THREE.Euler;
  type: string;
  revoluteMiddlePosition: THREE.Vector3;
  lastRotation: THREE.Matrix4;
  basePosition: THREE.Vector3;
  scale?: THREE.Vector3;
  last: boolean;
}
export const ArrowAxes = ({
  position,
  rotation,
  type,
  revoluteMiddlePosition,
  lastRotation,
  basePosition = new Vector3(0, 0, 0),
  scale = new Vector3(1, 1, 1),
  last = false,
}: ArrowAxesProps) => {
  var lineScene = new THREE.Scene();
  var jointScene = new THREE.Scene();

  const cgeometry =
    type == "revolute"
      ? new THREE.CylinderGeometry(2, 2, 5, 32)
      : new THREE.BoxGeometry(3, 6, 3);
  const cmaterial = new THREE.MeshBasicMaterial({ color: 8421504 });
  const cylinder = new THREE.Mesh(cgeometry, cmaterial);
  jointScene.add(cylinder);

  var material1 = new THREE.MeshBasicMaterial({ color: 0 });
  const points1 = [];
  points1.push(position);
  points1.push(revoluteMiddlePosition);

  var tubeGeometry1 = new THREE.TubeGeometry(
    new THREE.CatmullRomCurve3(points1),
    1,
    0.5
  ); // Adjust radius for thickness

  var tubeMesh1 = new THREE.Mesh(tubeGeometry1, material1);

  lineScene.add(tubeMesh1);
  var material2 = new THREE.MeshBasicMaterial({
    color: type == "revolute" ? 0 : 8421504,
  });
  const points2 = [];
  points2.push(revoluteMiddlePosition);
  points2.push(basePosition);

  // Create the tube geometry
  var tubeGeometry2 = new THREE.TubeGeometry(
    new THREE.CatmullRomCurve3(points2),
    1,
    0.5
  ); // Adjust radius for thickness

  // Create the tube mesh
  var tubeMesh2 = new THREE.Mesh(tubeGeometry2, material2);

  lineScene.add(tubeMesh2);

  const geometry = new THREE.SphereGeometry(0.5, 32, 32);
  const spherematerial = new THREE.MeshBasicMaterial({ color: 0 });
  const sphere1 = new THREE.Mesh(geometry, spherematerial);
  sphere1.position.set(position.x, position.y, position.z);
  const sphere2 = new THREE.Mesh(geometry, spherematerial);
  sphere2.position.set(
    revoluteMiddlePosition.x,
    revoluteMiddlePosition.y,
    revoluteMiddlePosition.z
  );
  lineScene.add(sphere1);
  lineScene.add(sphere2);

  const arrowScene = getArrowAxes(last);

  return (
    <>
      <group position={position} rotation={rotation} scale={scale}>
        <primitive object={arrowScene} />
        <Text
          color="black" // default
          anchorX="center" // default
          anchorY="middle" // default
          position={[11, 0, 0]}
          scale={[1, 1, 1]}
        >
          X
        </Text>
        <Text
          color="black" // default
          anchorX="center" // default
          anchorY="middle" // default
          position={[0, 11, 0]}
          scale={[1, 1, 1]}
        >
          Y
        </Text>
        <Text
          color="black" // default
          anchorX="center" // default
          anchorY="middle" // default
          position={[0, 0, 11]}
          scale={[1, 1, 1]}
        >
          Z
        </Text>
      </group>
      <primitive object={lineScene} />
      <group
        position={basePosition}
        rotation={new THREE.Euler().setFromRotationMatrix(lastRotation)}
        scale={scale}
      >
        <primitive
          object={jointScene}
          rotation={new THREE.Euler(Math.PI / 2, 0, 0)}
        />
      </group>
    </>
  );
};
